<ng-template #loadingBlock>
    <div *ngIf="showLoader" class="center spinner-container">
        <app-fake-stepper [options]="loaderOptions"></app-fake-stepper>
    </div>
</ng-template>
<app-graph-mixed *ngIf="isReady else loadingBlock" [config]="graphConfigObs"></app-graph-mixed>